import BgMusic from './bg-music';
import Default from './default';

BgMusic.Default = Default;

export default BgMusic;
